module.exports = __webpack_public_path__ + "img/impressum.15f519ca.png";